module.exports = __webpack_public_path__ + "static/media/predicting.16bba302.svg";